import appBulkInvoiceItemTypesUploadDetails from "../../views/appSettings/bulkInvoiceItemTypesUploadDetailsView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("bulkinvoiceitemtypesuploaddetails", {
    url: "bulk-invoice-item-types-upload-details/:id",
    parent: "app",
    views: {
      view: {
        template: appBulkInvoiceItemTypesUploadDetails,
      },
    },
    reloadOnSearch: false,
    data: { title: "BulkInvoiceItemTypesUploadDetails" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploadDetails/bulkInvoiceItemTypesUploadDetails.urls.js